// src/Admin/components/MultiStepGameForm/initialFormState.js
import {
  DEFAULT_CONNECTIONS_FORM_FIELDS,
} from "./defaults/connectionsDefaults";
import {
  DEFAULT_MEMORY_FORM_FIELDS,
} from "./defaults/memoryDefaults";

const toLocalDateTimeInput = (isoString) => {
  try {
    if (!isoString) return "";
    const d = new Date(isoString);
    if (isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const hh = pad(d.getHours());
    const min = pad(d.getMinutes());
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  } catch (_) {
    return "";
  }
};

export const getInitialFormState = (game = null) => {
  const normalizedType = game?.type || "";
  const isMemory = normalizedType === "memory";
  const typeDefaults = isMemory
    ? DEFAULT_MEMORY_FORM_FIELDS
    : DEFAULT_CONNECTIONS_FORM_FIELDS;
  return {
    // Basic info
    name: game?.name || "",
    client: game?.client || "",
    type: normalizedType,
    isActive: game?.isActive !== undefined ? game.isActive : true,
    adminNotes: game?.adminNotes || "",
    activeFrom: game?.activeFrom ? toLocalDateTimeInput(game.activeFrom) : "",
    activeUntil: game?.activeUntil
      ? toLocalDateTimeInput(game.activeUntil)
      : "",

    // Intro section
    introMessage: game?.introMessage || {
      title: normalizedType ? typeDefaults.introMessage.title : "",
      instructions: normalizedType ? typeDefaults.introMessage.instructions : "",
      howTo: normalizedType ? typeDefaults.introMessage.howTo : "",
    },
    terms: game?.terms || "",
    termsType: (() => {
      const value = (game?.terms || "").trim();
      if (!value) return "none";
      return /^https?:\/\//i.test(value) ? "url" : "text";
    })(),

    // Branding section
    makeGradient: Boolean(game?.reveal?.makeGradient),
    backgroundColor: game?.backgroundColor || "#FFFFFF",
    backgroundImage: game?.backgroundImage || "",
    bannerImage: game?.bannerImage || "",
    textColor: game?.textColor || "#000000",
    buttonColor: game?.buttonColor || "#000000",

    // Content section
    gameData: game?.gameData || (normalizedType ? typeDefaults.gameData : {}),

    // Colors section
    categoryColors: game?.categoryColors || typeDefaults.categoryColors,
    cardBackgroundColor:
      game?.cardBackgroundColor || typeDefaults.cardBackgroundColor,
    cardTextColor: game?.cardTextColor || typeDefaults.cardTextColor,
    categoryTextColor: game?.categoryTextColor || typeDefaults.categoryTextColor,

    // Success section
    successMessage: game?.successMessage || typeDefaults.successMessage,
    redirectButtonText: game?.redirectButtonText || typeDefaults.redirectButtonText,
    redirectButtonLink: game?.redirectButtonLink || typeDefaults.redirectButtonLink,
    redirectButtonColor:
      game?.redirectButtonColor || typeDefaults.redirectButtonColor,

    // Legacy reveal (for backward compatibility)
    reveal: game?.reveal || typeDefaults.reveal,
  };
};

// Default values for each client
export const CLIENT_DEFAULTS = {
  blueprint: {
    backgroundColor: "#FFFFFF",
    textColor: "#000000",
    categoryColors: ["#DE183B", "#60116A", "#333333", "#666666"],
    redirectButtonColor: "#DE183B",
    categoryTextColor: "#FFFFFF",
  },
  delta: {
    backgroundColor: "#1a1a1a",
    textColor: "#FFFFFF",
    categoryColors: ["#FF6B6B", "#4ECDC4", "#45B7D1", "#96CEB4"],
    redirectButtonColor: "#FF6B6B",
    categoryTextColor: "#FFFFFF",
  },
  virgin: {
    backgroundColor: "#E10A0A",
    textColor: "#FFFFFF",
    categoryColors: ["#E10A0A", "#B80808", "#8A0606", "#5C0404"],
    redirectButtonColor: "#E10A0A",
    categoryTextColor: "#FFFFFF",
  },
  sfta: {
    backgroundColor: "#FFFFFF",
    textColor: "#000000",
    categoryColors: ["#dc4405", "#dc4405", "#dc4405", "#dc4405"],
    redirectButtonColor: "#dc4405",
    categoryTextColor: "#FFFFFF",
  },
};
